// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialLinks_social__CsO5t {
  align-items: center;
  display: flex;
  gap: 24px;
}
.SocialLinks_social__CsO5t .SocialLinks_socialItem__11JGB path {
  transition: all 0.2s linear;
}
.SocialLinks_social__CsO5t .SocialLinks_socialItem__11JGB:hover path {
  fill: #ead40c;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/social-links/SocialLinks.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AACF;AAEI;EACE,2BAAA;AAAN;AAIE;EACE,aAAA;AAFJ","sourcesContent":[".social {\n  align-items: center;\n  display: flex;\n  gap: 24px;\n\n  .socialItem {\n    path {\n      transition: all 0.2s linear;\n    }\n  }\n\n  .socialItem:hover path {\n    fill: #ead40c;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"social": `SocialLinks_social__CsO5t`,
	"socialItem": `SocialLinks_socialItem__11JGB`
};
export default ___CSS_LOADER_EXPORT___;
